import api from "../..";
import type { GetPostsParams, Post } from "./types";

export const getPosts = async (input: GetPostsParams = {}): Promise<Post[]> => {

  const { params } = input;

  return await api.get("/admin/posts/", { params })
  .then(res => res.data.data)
  .catch(() => {return []});
};
